import { render, staticRenderFns } from "./HealthScore.vue?vue&type=template&id=36c388ad"
import script from "./HealthScore.vue?vue&type=script&lang=js"
export * from "./HealthScore.vue?vue&type=script&lang=js"
import style0 from "./HealthScore.vue?vue&type=style&index=0&id=36c388ad&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports